<script>
    import ToggleSwitch from "../components/ToggleSwitch.svelte";
    import Info from "../components/profile/Info.svelte";
    import Address from "../components/profile/Address.svelte";
    import OpeningHours from "../components/profile/OpeningHours.svelte";
    import { business, saveChanges } from "../firebase/auth";
    import { getGeocode } from "../firebase/firebase";
    import { GeoPoint } from "firebase/firestore";
    import Statusbar from "../components/profile/Statusbar.svelte";
    import Avatar from "../components/images/Avatar.svelte";
    import Title from "../components/images/Title.svelte";
    import FollowerStats from "../components/profile/FollowerStats.svelte";

    let editing = {
        info: false,
        address: false,
        openingHours: false
    };

    $: unsavedChanges = editing.info || editing.address || editing.openingHours;

    async function updateGeocode() {
        const address = $business.address;
        try {
            const res = await getGeocode(address);
            console.log("geocode:", res);
            $business.location = {
                geohash: res.data.geohash,
                place_id: res.data.place_id,
                geopoint: new GeoPoint(res.data.lattitude, res.data.longitude),
            }
        } catch (error) {
            console.log(error)
            $business.location = {
                geohash: "",
            }
        } finally {
            return saveChanges(["address.street", "address.houseNumber", "address.addition", "address.city", "address.zip", "address.state", "location"]);
        }
    }
    
    async function publish() {
        $business.visible = true;
        await saveChanges(["visible", "name", "description", "socials", "address.street", "address.houseNumber", "address.addition", "address.city", "address.zip", "address.state", "location", "openingHours.regular", "openingHours.holidays", "openingHours.specialDays"]);
        editing = {
            info: false,
            address: false,
            openingHours: false
        };
        editing = editing;
        return
    }

    async function save() {
        await saveChanges(["name", "description", "socials", "address.street", "address.houseNumber", "address.addition", "address.city", "address.zip", "address.state", "location", "openingHours.regular", "openingHours.holidays", "openingHours.specialDays"]);
        editing = {
            info: false,
            address: false,
            openingHours: false
        };
        editing = editing;
        return
    }

    async function hide() {
        $business.visible = false;
        return saveChanges(["visible"]);
    }

</script>


{#if $business}
    <div class="profile-header">
        <Title businessId={$business.id}/>
        <div class="profile-img">
            <Avatar businessId={$business.id} />
        </div>
    </div>
    <Info bind:name={$business.name} bind:description={$business.description} bind:socials={$business.socials} on:save={() => {editing.info = false; saveChanges(["name", "description", "socials"])}} on:edit={() => {editing.info = true}}/>
    <FollowerStats followerCount={$business.followerCount} />
    <Address bind:address={$business.address} bind:location={$business.location} on:save={() => {editing.address = false; updateGeocode()}} on:edit={() => {editing.address = true;}}/>
    <hr>
    <OpeningHours bind:openingHours={$business.openingHours} on:save={() => {editing.openingHours = false; saveChanges(["openingHours.regular", "openingHours.holidays", "openingHours.specialDays"])}} on:edit={() => {editing.openingHours = true}}/>
    <!-- <ToggleSwitch label="sichtbar" screenreaderText="Betrieb öffentlich anzeigen" bind:checked={$business.visible} on:change={() => {saveChanges(["visible"])}}/>
    <br> -->
    <Statusbar bind:business={$business} bind:unsavedChanges on:publish={publish} on:save={save} on:hide={hide}/>
{/if}

<style>
    .profile-header {
        position: relative;
    }

    .profile-img {
        position: absolute;
        bottom: -4px;
        left: 0;
        right: 0;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
    }
</style>